import { FC, PropsWithChildren } from "react";
import classes from './lessonItem.module.scss'
import { ILesson } from "../../model/types";
import { formatUtcToMsk } from "../../../../shared/lib/helpers/formatUtcToMsk";
import { Link } from "react-router-dom";
import { LabelText } from "../../../../shared/ui/sign";
import { useAppSelector } from "../../../../app/store/store";
import { FEATURES, FEATURE_SECTIONS, hasFeature, hasFeatureGrant } from "../../../my";

interface IProps {
    lesson: ILesson;
    showFio?: boolean;
}

export const LessonItemMobile: FC<IProps & PropsWithChildren> = ({lesson, showFio, children}) => {
    const {my} = useAppSelector(state => state.myReducer)
    const canOpenStudent = hasFeature(my, FEATURE_SECTIONS.STUDENTS)
        && hasFeatureGrant(my, FEATURES.STUDENTS.CARD_READ)

    return (
        <section
            className={classes.itemMobile}
        >
            <LabelText
                label="Дата"
                text={formatUtcToMsk(lesson.date) + (" (мск)")}
            />
            {
                showFio
                    &&
                <LabelText
                    label="ФИО"
                    text={
                        canOpenStudent
                            ? <Link to={'/students/' + lesson.student_id}>{lesson.student_full_name}</Link>
                            : lesson.student_full_name
                    }
                />
            }
            <LabelText
                label="Длительность"
                text={String(lesson.duration_minutes)}
            />
            <LabelText
                label="Действия"
                text={
                    <>
                        {children}
                    </>
                }
            />
        </section>
    )
}
